module.exports = __webpack_public_path__ + "static/media/Lockton_Marine_P&I_shipowners.05698ef0.pdf";